import { c as _c } from "react/compiler-runtime";
import GroupHeader from "../header/GroupHeader";
import GroupSelect from "../select/GroupSelect";
export default function Groups() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-pb-4"><GroupHeader /><GroupSelect /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}